const en = {
  metaTitle: "SkillSynergy | Blog",
  metaDescription:
    "Notes on programming, AI and learning to build software, from the SkillSynergy instructors.",
  navLabel: "Blog",
  eyebrow: "Writing",
  title: "Notes from the classroom",
  lead: "Occasional writing on programming, AI and what is actually worth learning.",
  readTime: (minutes: number) => `${minutes} min read`,
  backToBlog: "Back to all posts",
  publishedOn: "Published",
  englishOnlyNotice: "This article is available in English only.",
  readMore: "Read the article",
};

export default en;
